<template>
  <div>
    <h3 class="title-page text-center">Planos</h3>
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card-content>
          <div>
            <md-steppers :md-active-step.sync="active" md-linear md-theme-primary :md-vertical="isVertical">
              <md-step id="selectPlanStep" md-label="Selecionar plano" md-description="Selecione 1" :md-done.sync="selectPlanStep">
                <div class="md-layout" style="text-align: center">
                  <div class="md-layout-item content-center text-center" style="margin: 20px 0">
                    <div class="switch-button">
                      <span class="active" :style="yearly ? 'left: 50%;' : 'left: 0.5%;'" />
                      <button @click="selectTypePlan(false)" :class="!yearly ? 'switch-button-case active-case' : 'switch-button-case'">Mensal</button>
                      <button @click="selectTypePlan(true)" :class="yearly ? 'switch-button-case active-case' : 'switch-button-case'">
                        Anual
                        <md-tooltip md-direction="right">Economize 10% anualmente</md-tooltip>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="md-layout">
                  <div v-for="plan in plans" :key="plan.title">
                    <div class="md-layout-item">
                      <div class="plan-card-container">
                        <div class="plan-header" :style="{ background: plan.background }">
                          <div v-if="plan.id === 2" class="svg-more">
                            <svg width="96" height="95" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0 3h74c9.941 0 18 8.059 18 18v74L45.313 49.687 0 3z" fill="#D5F900"></path>
                              <path
                                d="M69.245 19.172l-6.416 6.416-1.287-1.287 4.173-4.173-5.892 2.454-.975-.974 2.446-5.901-4.174 4.173-1.287-1.287 6.416-6.416 1.462 1.461-2.73 6.812 6.812-2.73 1.452 1.452zm-2.91 4.793c.515-.515 1.072-.87 1.673-1.066.606-.19 1.192-.218 1.755-.083.57.141 1.073.43 1.508.864.38.38.634.788.763 1.223.135.441.172.864.11 1.268l.727-.726 1.296 1.296-5.093 5.093-1.296-1.296.744-.745a2.75 2.75 0 01-1.286-.092c-.442-.135-.852-.392-1.232-.772a3.093 3.093 0 01-.846-1.507 3.35 3.35 0 01.092-1.765c.202-.607.564-1.17 1.085-1.692zm3.99 4.026c.312-.312.517-.64.615-.983.104-.35.11-.686.019-1.011a1.84 1.84 0 00-.488-.855 1.843 1.843 0 00-.836-.487 1.894 1.894 0 00-1.011.018c-.343.098-.668.3-.975.607a2.42 2.42 0 00-.625.992 1.995 1.995 0 00-.027 1.02 1.8 1.8 0 00.478.846c.239.24.52.405.845.497.331.086.668.08 1.011-.019.35-.104.68-.312.993-.625zm6.358.053a1.146 1.146 0 01-.359-.781c0-.294.108-.549.322-.763a1 1 0 01.754-.313c.3.006.564.123.79.35.227.226.34.487.34.78a.981.981 0 01-.303.764 1.021 1.021 0 01-.772.312c-.288-.006-.545-.122-.772-.349zm.027 1.241l-5.092 5.093-1.287-1.287 5.093-5.093 1.286 1.287zm-1.954 8.396c-.417-.417-.718-.864-.901-1.342a2.91 2.91 0 01-.175-1.407c.067-.447.248-.836.542-1.167l1.296 1.296c-.171.22-.239.478-.202.772.043.3.19.576.441.827.246.246.485.386.717.423.24.043.435-.012.589-.165.165-.166.202-.374.11-.625-.08-.252-.254-.61-.524-1.076a9.97 9.97 0 01-.653-1.222 2.365 2.365 0 01-.174-1.076c.03-.374.217-.732.56-1.075.282-.282.62-.46 1.012-.534.398-.067.815-.018 1.25.148.441.171.867.462 1.278.873.606.606.937 1.244.992 1.912.062.662-.147 1.268-.625 1.82l-1.231-1.232a.914.914 0 00.22-.735c-.024-.27-.162-.53-.413-.782-.233-.233-.457-.37-.672-.413a.584.584 0 00-.542.174c-.171.172-.218.39-.138.653.086.257.264.613.533 1.066.276.46.484.858.625 1.195.141.337.194.696.157 1.076-.025.38-.203.741-.534 1.085-.294.294-.64.474-1.038.542-.392.073-.81.024-1.25-.147-.43-.172-.846-.46-1.25-.864zM48.148 20.704l-8.77 4.063-1.562-1.563 4.063-8.77 1.378 1.38-3.336 6.866 6.857-3.346 1.37 1.37zm1.746 9.265a4.305 4.305 0 01-.533.46l-3.723-3.723c-.337.398-.497.815-.478 1.25.018.435.193.818.524 1.149.478.478 1.023.613 1.636.404l1.388 1.388a3.314 3.314 0 01-2.059.368c-.73-.104-1.397-.46-2.004-1.066a3.846 3.846 0 01-1.002-1.646 3.35 3.35 0 01.018-1.838c.184-.613.537-1.18 1.057-1.7.528-.528 1.097-.883 1.71-1.067a3.175 3.175 0 011.82-.018c.601.171 1.152.508 1.655 1.01.484.485.812 1.021.984 1.61a3.048 3.048 0 010 1.783c-.166.594-.497 1.14-.993 1.636zm-.965-1.7c.325-.338.468-.72.432-1.15-.03-.435-.215-.821-.552-1.158-.319-.319-.686-.49-1.103-.515-.404-.024-.803.11-1.195.405l2.418 2.417zm7.236 2.952c.607.606.904 1.29.892 2.05-.007.753-.353 1.474-1.04 2.16l-2.987 2.987-1.287-1.287 2.813-2.812c.405-.405.613-.816.625-1.232.019-.423-.147-.81-.496-1.158-.356-.356-.748-.527-1.177-.515-.416.012-.827.22-1.232.625l-2.813 2.813-1.286-1.287 5.092-5.093 1.287 1.287-.634.634a2.468 2.468 0 011.167.138c.399.141.757.371 1.076.69zm.323 5.526c.515-.515 1.072-.87 1.673-1.067a3.22 3.22 0 011.765-.073c.57.14 1.072.429 1.507.864.331.33.573.72.727 1.167.159.442.208.87.146 1.287l2.418-2.417 1.305 1.305-6.802 6.802-1.305-1.305.753-.754c-.41.092-.836.07-1.277-.064-.441-.135-.852-.392-1.232-.772a3.093 3.093 0 01-.846-1.508 3.315 3.315 0 01.083-1.774c.202-.607.564-1.17 1.085-1.691zm3.99 4.026c.312-.313.517-.64.615-.984.104-.349.11-.686.018-1.01a1.84 1.84 0 00-.487-.856 1.843 1.843 0 00-.836-.487 1.894 1.894 0 00-1.011.018c-.343.099-.668.3-.975.607a2.42 2.42 0 00-.625.993 1.995 1.995 0 00-.027 1.02c.085.331.245.613.478.846.239.239.52.404.845.496.331.086.668.08 1.012-.018.349-.104.68-.313.992-.625zm6.358.053a1.146 1.146 0 01-.359-.782c0-.294.108-.548.322-.763a1 1 0 01.754-.312c.3.006.564.122.79.349.227.227.34.487.34.781a.98.98 0 01-.303.763 1.022 1.022 0 01-.772.313c-.288-.006-.545-.123-.772-.35zm.028 1.24l-5.093 5.093-1.287-1.287 5.093-5.092 1.287 1.286zm-1.588 3.469c.515-.515 1.073-.87 1.673-1.066a3.22 3.22 0 011.765-.074c.57.141 1.073.43 1.508.864.33.331.573.72.726 1.168.16.44.208.87.147 1.287l2.418-2.418 1.305 1.305-6.803 6.803-1.305-1.306.754-.753c-.41.092-.837.07-1.278-.065-.441-.135-.852-.392-1.232-.772A3.095 3.095 0 0164.11 49a3.314 3.314 0 01.082-1.774c.203-.606.564-1.17 1.085-1.691zm3.99 4.026c.312-.312.517-.64.616-.983.104-.35.11-.687.018-1.012a1.84 1.84 0 00-.487-.854 1.844 1.844 0 00-.837-.488 1.894 1.894 0 00-1.01.019c-.344.098-.669.3-.975.606a2.421 2.421 0 00-.625.993 1.997 1.997 0 00-.028 1.02c.086.332.245.613.478.846.239.24.52.405.846.497.33.086.668.08 1.01-.019.35-.104.681-.312.994-.625zm2.185 7.444a3.846 3.846 0 01-1.002-1.646 3.415 3.415 0 010-1.857c.178-.619.527-1.189 1.048-1.71.52-.52 1.094-.867 1.719-1.038a3.387 3.387 0 011.866.027 3.823 3.823 0 011.664 1.002c.49.49.824 1.045 1.002 1.664a3.3 3.3 0 01.018 1.857c-.165.631-.508 1.207-1.03 1.728-.52.521-1.1.861-1.737 1.02a3.454 3.454 0 01-1.884-.027c-.613-.184-1.168-.524-1.664-1.02zm1.121-1.122c.233.233.506.395.819.487.324.092.662.086 1.01-.018.35-.104.687-.319 1.012-.643.484-.485.726-.984.726-1.499a1.742 1.742 0 00-.533-1.324 1.743 1.743 0 00-1.324-.533c-.502.013-.996.26-1.48.745-.484.484-.738.977-.763 1.48-.012.502.166.938.533 1.305z"
                                fill="#1A1A33"
                              ></path>
                            </svg>
                          </div>

                          <span style="font-size: 22px">{{ plan.title }}</span>
                          <p class="amount-container">
                            <span>R$</span>
                            <span class="amount">
                              <span v-if="!yearly">{{ plan.amount.month }},00</span>
                              <span v-else>{{ plan.amount.year / 12 }},00</span>
                            </span>
                            <span>/mês</span>
                          </p>
                          <span v-if="yearly" style="font-size: 17px; margin-top: 5px"> R$ {{ plan.amount.year }},00 / Ano </span>
                        </div>
                        <div class="plan-body" :style="{ border: plan.id === 2 ? '2px solid rgb(0, 18, 42)' : 'none' }">
                          <div class="plan-item" v-for="item in planItems" :key="item">
                            <span v-if="plan.items.some((el) => el === item)">
                              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 9A9 9 0 110 9a9 9 0 0118 0z" fill="#00D37F"></path>
                                <path
                                  d="M14.032 7.066a.676.676 0 000-.956l-.987-.988a.676.676 0 00-.957 0l-5.015 5.011-1.07-1.069L9.02 12.08l.002-.002 5.011-5.01z"
                                  fill="#fff"
                                ></path>
                                <path
                                  d="M5.099 8.067a.676.676 0 00-.957 0l-.987.987a.676.676 0 000 .956l2.03 2.03 1.466 1.466a.677.677 0 00.956 0l1.468-1.463-3.016-3.016-.96-.96z"
                                  fill="#fff"
                                ></path>
                              </svg>
                            </span>

                            <span v-else>
                              <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 9A9 9 0 110 9a9 9 0 0118 0z" fill="#FF3E6C"></path>
                                <rect x="11.836" y="4" width="3" height="11.08" rx="1" transform="rotate(45 11.836 4)" fill="#fff"></rect>
                                <rect x="4" y="6" width="3" height="11.08" rx="1" transform="rotate(-45 4 6)" fill="#fff"></rect>
                              </svg>
                            </span>

                            <p>{{ item }}</p>
                          </div>
                          <md-button class="md-raised md-primary btn-select" @click="selectPlan(plan.id)">Selecionar</md-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </md-step>

              <md-step id="paymentStep" md-label="Resumo pagamento" :md-done.sync="paymentStep">
                <div class="md-layout">
                  <div class="md-layout-item" v-if="selectedPlan">
                    <md-card>
                      <md-card-header class="md-card-header-icon">
                        <div class="card-icon">
                          <md-icon>perm_identity</md-icon>
                        </div>
                        <h4 class="title">Imposto de Renda Variável</h4>
                      </md-card-header>

                      <md-card-content>
                        <div class="md-layout">
                          <div class="md-layout-item md-size-100">
                            <span
                              >Calcule e pague facilmente seus impostos em ações, ETFs, FIIs e Day Trade e Criptoativos. Tenha acesso rápido às informações
                              necessárias para a sua Declaração Anual de Imposto de Renda.</span
                            >
                          </div>
                          <div v-if="packageOrder" class="md-layout-item md-size-100">
                            <span>{{packageOrder.description}}</span><br />
                            <span>
                              Valor: {{ packageOrder.order.value | CurrencyFormat }}
                            </span><br />
                          </div>
                          <div v-else class="md-layout-item md-size-100">
                            <span>Nome do plano: {{ plansMonth[selectedPlan].name }}</span
                            ><br />
                            <span v-if="!yearly"
                              >Valor do plano:
                              {{ plansMonth[selectedPlan].value }}
                              Mensal</span
                            >
                            <span v-else
                              >Valor do plano:
                              {{ plansYearly[selectedPlan].value }}
                              Anual</span
                            ><br />
                          </div>
                          <md-field class="md-form-group">
                            <label>Cupom</label>
                            <md-input v-model="coupon" />
                          </md-field>
                          <span v-if="couponError">{{couponError}}</span>
                        </div>
                      </md-card-content>
                      <md-card-actions v-if="!packageOrder">
                        <md-button @click="setDone"> Avançar </md-button>
                        <md-button @click="active = 'selectPlanStep'"> Mudar de plano </md-button>
                      </md-card-actions>
                    </md-card>
                  </div>
                </div>
              </md-step>
              <md-step id="doneStep" md-label="Conclusão">
                <div class="button-container">
                  <md-button @click="openPayment"
                    class="md-success md-round mt-4" 
                    type="submit" 
                    slot="footer"> Ir para pagamento </md-button>
                </div>
              </md-step>
            </md-steppers>
          </div>
        </md-card-content>
      </div>
    </div>
  </div>
</template>
<script>
import VCreditCard from 'v-credit-card'
import 'v-credit-card/dist/VCreditCard.css'
import Swal from 'sweetalert2'

export default {
  data: () => ({
    plansMonth: {
      1: {
        name: 'Plano Trader',
        value: 'R$ 20,00',
        cod: 7,
      },
      2: {
        name: 'Plano Essencial',
        value: 'R$ 60',
        cod: 13,
      },
    },
    plansYearly: {
      1: {
        name: 'Plano Trader',
        value: 'R$ 216,00',
        cod: 8,
      },
      2: {
        name: 'Plano Essencial',
        value: 'R$ 648,00',
        cod: 14,
      },
    },
    planItems: [
      'Emissão de DARFs',
      'DAY Trade sem posição',
      'Renda variável',
      'Opções flexíveis',
      'Fundos imobiliários',
      'Rendimentos isentos',
      'Bens e direitos',
      'Empresas incentivadas',
      'ETFS',
      'Relação de proventos',
      'Previsão de resultados',
      'Informes para imposto de renda',
      'Importação de notas mensais',
    ],
    plans: [
      {
        id: 1,
        title: 'Trader',
        amount: {
          month: 20,
          year: 216,
        },
        background: '#00d37f',
        items: ['Emissão de DARFs', 'DAY Trade sem posição'],
      },
      {
        id: 2,
        title: 'Essencial',
        amount: {
          month: 60,
          year: 648.00,
        },
        background: 'rgb(0, 18, 42)',
        items: [
          'Emissão de DARFs',
          'DAY Trade sem posição',
          'Renda variável',
          'Opções flexíveis',
          'Fundos imobiliários',
          'Rendimentos isentos',
          'Bens e direitos',
          'Empresas incentivadas',
          'ETFS',
          'Relação de proventos',
          'Previsão de resultados',
          'Informes para imposto de renda',
          'Importação de notas mensais',
        ],
      },
    ],
    selectedPlan: null,
    active: 'selectPlanStep',
    selectPlanStep: false,
    paymentStep: false,
    secondStepError: null,
    yearly: false,
    profile: null,
    params: {},
    paramsPlan: {},
    addDecl: false,
    selectedPaymentMethod: 'CC',
    translationsCard: {
      name: {
        label: 'Nome',
        placeholder: 'Nome no cartão',
      },
      card: {
        label: 'Número do cartão',
        placeholder: '0000 0000 0000 0000',
      },
      expiration: {
        label: 'Vencimento',
      },
      security: {
        label: 'CVV',
        placeholder: 'CVV',
      },
    },
    name: '',
    cardNumber: '',
    expiration: '',
    monthExpiration: '',
    yearExpiration: '',
    security: '',
    codPix: null,
    cpfCnpj: null,
    coupon: null,
    sendOrder: null,
    getOrder: null,
    pixImg: null,
    cardToken: {},
    checkPayment: null,
    orderId: null,
    isVertical: null,
    copied: false,
    packageOrder: null,
    packageOrderId: null,
    couponError: null,
    paymentLink: null
  }),
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    copyLink() {
      // Copy the text inside the text field
      navigator.clipboard.writeText(this.codPix)
      this.$store.dispatch('alerts/successBottom', 'Link copiado.')
      this.copied = true
      setTimeout(() => (this.copied = false), 5000)
    },
    selectTypePlan(newYearly) {
      this.yearly = newYearly
    },
    processCreditCardPayment() {},
    async getPayment() {
      this.params = {
        token: this.$store.getters.token,
        orderId: this.orderId,
      }
      this.getOrder = await this.$store.dispatch('payments/getOrder', this.params)
      if (this.getOrder.result == 2) {
        this.third = true
        this.active = 'doneStep'
        clearInterval(this.checkPayment)
      }
    },
    selectPlan(planId) {
      this.selectPlanStep = true
      this.active = 'paymentStep'
      this.selectedPlan = planId
    },
    autoSelectPlan(planId) {
      this.selectPlanStep = true
      this.active = 'paymentStep'
      switch (planId) {
        case '7':
          this.selectedPlan = 1
          break;
        case '8':
          this.yearly = true;
          this.selectedPlan = 1
          break;
        case '13':
          this.selectedPlan = 2
          break;
        case '14':
          this.yearly = true;
          this.selectedPlan = 2
          break;
      }
       
    },
    async setDone() {
      this.couponError = null;
      Swal.showLoading()
      var selectedPlan;
      if(this.packageOrder){
        selectedPlan = null
      }else{
        selectedPlan = !this.yearly ? this.plansMonth[this.selectedPlan].cod : this.plansYearly[this.selectedPlan].cod
      }
      this.params = {
        token: this.$store.getters.token,
        plan: selectedPlan,
        coupon: this.coupon,
        payment_method: this.selectedPaymentMethod
      }
      try{
        this.sendOrder = await this.$store.dispatch('payments/sendOrder', this.params)
      }catch(error){
        console.log(error.response.status)
        console.log(error.response)
        console.log(error.response.data[0].code)
        if(error.response && error.response.status == 400 && error.response.data[0].code == "coupon_not_found"){
          this.couponError = 'Cupom inválido, confira e tente novamente!';
        }else{
          this.couponError = "Ocorreu um erro, verifique os dados e tente novamente.";
        }
        Swal.close()
        return
      }
      this.paymentLink = this.sendOrder.result;
      this.paymentStep = true
      this.active = 'doneStep'
      Swal.close()
      openPayment();
    },
    openPayment(){
      window.open(this.paymentLink);
    },
    async getProfile() {
      this.params = {
        token: this.$store.getters.token,
      }
      this.profile = await this.$store.dispatch('profile/me')
    },
    handleResize() {
      this.isVertical = window.innerWidth < 790
    },
  },
  mounted() {
    var this_ori = this;
    this_ori.getProfile()
    this_ori.handleResize()
    window.addEventListener('resize', this_ori.handleResize)
    setTimeout(function(){
      if(!!this_ori.$store.selectedPlan) {
        this_ori.autoSelectPlan(this_ori.$store.selectedPlan);
      }
      if(!!localStorage.getItem('coupon')) {
        this_ori.coupon = localStorage.getItem('coupon');
      }
    }, 500);
  },
}
</script>
<style lang="scss">
.plan-card-container {
  border-radius: 20px 20px 0 0;
  min-width: 470px;
}

@media (max-width: 690px) {
  .md-layout-item {
    padding: 0;
  }
  .plan-card-container {
    min-width: 250px;
  }
}

.plan-header {
  position: relative;
  padding: 10px;
  border-radius: 20px 20px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 152px;
  span {
    color: #fff;
    font-weight: 700;
  }
  gap: 8px;
}

.plan-body {
  background-color: white;
  box-shadow: 0 1px 15px 3px rgb(201 211 223 / 46%);
  border-radius: 0 0 20px 20px;
  padding: 10px 30px;
  border: 2px solid #fff;
}

.plan-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #d3dce6;
  color: #818b9b;
  font-size: 16px;
  gap: 20px;
}

.md-layout-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 15px 0;
}

.amount-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: center;
}

.svg-more {
  position: absolute;
  right: -5px;
  top: -4px;
}

.btn-select {
  width: 100%;
  margin-top: 16px;
}

.amount {
  font-size: 56px;
}

.content-center {
  display: flex;
}
</style>
